module.exports = __webpack_public_path__ + "static/share-65d63ea35b6910524c8bb15634d0522f.jpg";